import React from 'react';
import { Modal } from '@odin-labs/components';
import { PromptTimesIcon } from './PromptTimesIcon';

export type SavingInProgressModalProps = {
  open: boolean;
  onLeave: () => void;
  onStay: () => void;
};

/**
 * Shown instead of the unsaved changes warning while a save is in progress:
 * there is nothing more to save, only whether to wait for the one running.
 */
export function SavingInProgressModal(
  props: SavingInProgressModalProps,
): React.ReactElement {
  const { open, onLeave, onStay } = props;
  return (
    <Modal
      size="xs"
      open={open}
      setOpen={onStay}
      title="Your changes are still saving"
      titleAlignment="center"
      text="You can leave now and the save will finish in the background. If it fails, the changes you made on this page will be lost."
      textAlignment="center"
      closeButtonBehavior="dismiss"
      cancelIcon={PromptTimesIcon}
      cancelText="Leave anyway"
      onCancel={onLeave}
      actionText="Stay on page"
      onAction={onStay}
    />
  );
}
